import React, { useState, useRef, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../SafeIcon';

const { FiLogOut, FiEdit2 } = FiIcons;

const ProfileMenu = ({ user, profile, onLogout, onEditProfile }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  const initials = profile?.full_name
    ? profile.full_name.split(' ').map((n) => n[0]).join('').toUpperCase().slice(0, 2)
    : (user?.email?.[0] || 'U').toUpperCase();

  const displayName = profile?.full_name || user?.email?.split('@')[0] || 'User';

  return (
    <div ref={ref} className="relative" style={{ zIndex: 99999 }}>
      <button
        onClick={() => setOpen((v) => !v)}
        title="Profile"
        className="flex items-center justify-center w-9 h-9 rounded-xl bg-[#c8f542] text-black font-black text-sm shadow-sm hover:scale-110 transition-transform"
      >
        {initials}
      </button>

      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ opacity: 0, x: 10, scale: 0.95 }}
            animate={{ opacity: 1, x: 0, scale: 1 }}
            exit={{ opacity: 0, x: 10, scale: 0.95 }}
            transition={{ duration: 0.15 }}
            style={{ zIndex: 999999, position: 'fixed' }}
            className="ml-3 w-64 bg-white rounded-2xl shadow-2xl border border-gray-100 overflow-hidden"
            ref={(el) => {
              if (el && ref.current) {
                const rect = ref.current.getBoundingClientRect();
                el.style.top = rect.top + 'px';
                el.style.left = (rect.right + 12) + 'px';
              }
            }}
          >
            {/* Profile Header */}
            <div className="p-4 bg-gray-50 border-b border-gray-100">
              <div className="flex items-center space-x-3">
                <div className="w-10 h-10 rounded-xl bg-[#c8f542] flex items-center justify-center text-black font-black text-sm shrink-0">
                  {initials}
                </div>
                <div className="flex-1 min-w-0">
                  <p className="font-bold text-gray-900 text-sm truncate">{displayName}</p>
                  <p className="text-xs text-gray-400 truncate">{user?.email}</p>
                </div>
              </div>
            </div>

            {/* Menu Items */}
            <div className="py-2">
              <button
                onClick={() => { onEditProfile(); setOpen(false); }}
                className="w-full flex items-center space-x-3 px-4 py-3 text-sm text-gray-700 hover:bg-gray-50 transition-colors"
              >
                <SafeIcon icon={FiEdit2} className="w-4 h-4 text-gray-400" />
                <span>Edit Profile</span>
              </button>
            </div>

            <div className="py-2 border-t border-gray-100">
              <button
                onClick={() => { onLogout(); setOpen(false); }}
                className="w-full flex items-center space-x-3 px-4 py-3 text-sm text-red-500 hover:bg-red-50 transition-colors"
              >
                <SafeIcon icon={FiLogOut} className="w-4 h-4" />
                <span className="font-medium">Sign out</span>
              </button>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default ProfileMenu;